// Cesty stránek shopu = `pages` z manifestu (src/config/bs.config.<shop>.mjs).
//
// Moduly nepíšou `/kontakt/` ani `/registrace/` natvrdo: slug se liší mezi
// shopy (SK `/kontakty/`, `/registracia/`) a admin slug info stránky může
// redaktor přejmenovat. Stránka, kterou shop nemá (SK blog, prodejna, B2B…),
// má v manifestu `null` — `page()` pak vrací null a odkazové seznamy ji
// vynechají přes `withPages()`. Neznámý klíč je chyba programu (překlep), ne
// stav shopu: hází hned při načtení modulu a chytá ho unit test
// tools/unit/pages.test.mjs dřív, než by v prohlížeči spadl bundle.

import SHOP from '../../config/shop.js';

/**
 * Href stránky shopu, případně s pod-cestou (`page('blog', 'rady-a-tipy/')`,
 * `page('brands', 'geko/')`).
 * @returns {string|null} null = shop stránku nemá
 */
export function page(key, sub) {
  if (!Object.prototype.hasOwnProperty.call(SHOP.pages, key)) {
    throw new Error('[bs] pages: neznama stranka "' + key + '"');
  }
  const base = SHOP.pages[key];
  return base === null ? null : base + (sub || '');
}

/** Admin/systémový slug stránky bez lomítek (`kontakt`), null = shop ji nemá. */
export function pageSlug(key) {
  const href = page(key);
  return href === null ? null : href.replace(/^\/|\/$/g, '');
}

/**
 * Body třída, kterou Shoptet dává stránce (`in-<poslední segment cesty>`):
 * `bodyClass('register')` → `in-registrace`. null = shop stránku nemá.
 */
export function bodyClass(key) {
  const href = page(key);
  return href === null ? null : 'in-' + href.split('/').filter(Boolean).pop();
}

/**
 * Mapa klíčovaná cestou stránky (`{sale: 'percent'}` → `{'/slevoakce/': 'percent'}`)
 * pro lookupy podle `root.path`; stránky, které shop nemá, vynechá.
 */
export function byPage(map) {
  const out = {};
  Object.keys(map).forEach(function (key) {
    const href = page(key);
    if (href !== null) out[href] = map[key];
  });
  return out;
}

/**
 * Cesta kořenové kategorie katalogu pod sémantickým klíčem (`catalogRoot('garden')`
 * → `/zahrada/`, SK totéž) — `catalog.roots` z manifestu. null = kořen shop nemá.
 */
export function catalogRoot(key) {
  if (!Object.prototype.hasOwnProperty.call(SHOP.catalog.roots, key)) {
    throw new Error('[bs] pages: neznamy koren "' + key + '"');
  }
  return SHOP.catalog.roots[key];
}

/** Jako `byPage()`, jen klíčem je kořen katalogu (`byRoot({garden: 'sprout'})`). */
export function byRoot(map) {
  const out = {};
  Object.keys(map).forEach(function (key) {
    const href = catalogRoot(key);
    if (href !== null) out[href] = map[key];
  });
  return out;
}

/** Odkazový seznam bez položek, jejichž stránku shop nemá (`href` null). */
export function withPages(items) {
  return items.filter(function (item) {
    return item && item.href !== null;
  });
}
